module.exports = __webpack_public_path__ + "static/media/fig_3.adac0871.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/rezum/fig_3.png
// module id = 614
// module chunks = 0